import { getLastUpdatedAtQuery } from 'helpers/helperFunctions';
import { WeekContentful } from 'models/WeekContentful';
import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';

export const getWeeks = baseService<string | undefined, WeekContentful[]>(
  (lastUpdatedAt) =>
    HttpClient.get(`/contentful/weeks${getLastUpdatedAtQuery(lastUpdatedAt)}`),
);
